namespace Matrix.Workflow {
    export class TaskInstanceDocumentColumns {
        static columnsKey = 'Workflow.TaskInstanceDocument';
    }
}
